<template>
  <!-- Change viewBox and fill params -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 26 32"
  >
    <g>
      <path
        fill="#ffb506"
        d="M4.426 22.042c-2.25-2.256-3.641-5.369-3.641-8.807s1.391-6.551 3.641-8.807l-0 0c2.239-2.252 5.34-3.646 8.766-3.646 0.014 0 0.028 0 0.043 0h-0.002c0.007 0 0.016-0 0.024-0 3.431 0 6.537 1.394 8.782 3.646l0 0c2.25 2.256 3.641 5.369 3.641 8.807s-1.391 6.551-3.641 8.807l0-0-8.769 8.844z"
      />
      <path
        fill="#464646"
        d="M13.233 1.588c0.007 0 0.014-0 0.022-0 3.21 0 6.115 1.303 8.215 3.409l0 0c2.106 2.095 3.409 4.995 3.409 8.199 0 0.014-0 0.027-0 0.041v-0.002c0 0.007 0 0.014 0 0.022 0 3.21-1.303 6.115-3.409 8.215l-0 0-8.201 8.266-8.276-8.276c-2.106-2.095-3.409-4.995-3.409-8.199 0-0.014 0-0.027 0-0.041v0.002c0-0.007-0-0.014-0-0.022 0-3.21 1.303-6.115 3.409-8.215l0-0c2.102-2.101 5.006-3.4 8.212-3.4 0.009 0 0.018 0 0.027 0h-0.001zM13.232-0.001c-0.007 0-0.015-0-0.023-0-3.648 0-6.949 1.482-9.336 3.876l-0 0c-2.394 2.396-3.874 5.705-3.874 9.359s1.48 6.963 3.874 9.359l9.398 9.406 9.322-9.396c2.394-2.396 3.874-5.705 3.874-9.359s-1.48-6.963-3.874-9.359l0 0c-2.386-2.4-5.69-3.886-9.34-3.886-0.006 0-0.013 0-0.019 0h0.001z"
      />
      <path
        fill="#464646"
        d="M14.79 7.632c0 0.007 0 0.015 0 0.024 0 0.713-0.578 1.291-1.291 1.291-0.021 0-0.042-0.001-0.063-0.002l0.003 0c-0.019 0.001-0.041 0.002-0.063 0.002-0.722 0-1.307-0.585-1.307-1.307 0-0.003 0-0.005 0-0.008v0c-0.001-0.015-0.001-0.033-0.001-0.051 0-0.729 0.591-1.32 1.32-1.32 0.018 0 0.036 0 0.054 0.001l-0.003-0c0.010-0 0.021-0 0.033-0 0.728 0 1.319 0.59 1.319 1.319 0 0.018-0 0.037-0.001 0.055l0-0.003z"
      />
      <path
        fill="#464646"
        d="M16.625 16.495v2.215h-6.4v-2.215h2.092v-4.121h-2.092v-2.215h4.304v6.337z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    }
  }
}
</script>
